<template>
  <h2 class="exerciseSubHeader" v-html="text">
  </h2>
</template>

<script>

  export default {
    name: 'PageSubHeader',
    props: ['text'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style lang="scss">
  @import "src/assets/scss/variables";

  .exerciseSubHeader {
    font-family: -apple-system, system-ui, BlinkMacSystemFont;
    font-style: normal;
    color: #2E2F34;
    margin-top: 100px;
    font-weight: normal;
    font-size: $title2FontSize;
    line-height: $title2LineHeight;
    margin: $primaryMargin;
  }

</style>
